import * as React from "react";
import { Action, Dispatch } from "redux";
import { connect } from "react-redux";
import { RootState } from "../../../../state";
import { getSelectList, getUserInformation } from "../../../../state/action";
import { createFeedback, loadSelectList } from "../../../../state/ui/action";
import { CompoundButton, DefaultButton, Dialog, DialogType, Dropdown, IDropdownOption, PrimaryButton, TextField } from "@fluentui/react";
import { useState } from "react";
import imageCompression from "browser-image-compression";

interface Props {
    orderId?: string;
    worker?: string;
}

const Feedback: React.FunctionComponent<Props & StateProps> = props => {

    const [showFeedbackDialog, setShowFeedbackDialog] = useState<boolean>(false);
    const [selectList, setSelectList] = useState<SelectListContainer | undefined>();
    const [selectValue, setSelectedValue] = useState<string>();
    const [description, setDescription] = useState<string>();
    const [file , setFile] = useState<File>();
    const inputFileRef = React.useRef(null);
    const onFeedbackClick = () =>
    {
        if(!props.selectList)
        {
            props.loadSelectList();
        }
        toggleDialog();
      
    }
    const toggleDialog = () => setShowFeedbackDialog(!showFeedbackDialog);

    const onListClick = (result: SelectListContainer) => () => setSelectList(result);

    const getSelectListOptions = (): IDropdownOption[] =>
    {
        if(selectList)
        {
            return selectList.values.sort((a, b) => a.key.localeCompare(b.key)).map(value => ({ key: value.key, text : value.value}));
        }
        return [];
    }
    const onSetSeletedValue = ( event: React.FormEvent<HTMLDivElement>, option: IDropdownOption ) => {
        setSelectedValue(option.key as string);
    };
    const onTextChange = (   e: React.SyntheticEvent<HTMLInputElement>, text: string ) => {
        setDescription(text);
    };

    const onUploadClick = () => {
        if (inputFileRef) {
            (inputFileRef as any).current.click();
        }
    }

     const uploadFile = async (file: File) => {
    
            var fileType = file["type"];
            let resultFile = file;
            if (fileType.search('image') >= 0) {
                try {
                    const options = {
                        maxSizeMB: 1,
                        maxWidthOrHeight: 1920,
                        useWebWorker: true,
                    }
                    resultFile = await imageCompression(file, options);
                } catch (error) {
                    console.log(error);
                }
            }
            setFile(resultFile);
        }
    
        const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
            if (event.target.files) {
                const file = event.target.files[0];
                uploadFile(file);
            }
    
        }

    const onSubmit = () =>
    {
        if(description && selectValue && selectList && props.orderId && props.user.id)
        {
            props.createFeedback({
                description: description,
                subType:selectValue,
                type: selectList.title,
                orderId: props.orderId,
                userId: props.user.id,
                userName: props.user.name,
                file: file,
                fileName: file ? file.name: undefined
            });
            setDescription(undefined);
            setSelectedValue(undefined);
            setSelectList(undefined);
            toggleDialog();
        }
     
    }
    return <>
       
        <Dialog minWidth={450} hidden={!showFeedbackDialog} onDismiss={toggleDialog}    dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: "Feedback",
                 
                }}>
          
            {props.selectList && props.selectList.map(list => <DefaultButton style={{marginRight:"10px"}} key={list.id} checked={selectList? list.id === selectList.id: false} onClick={onListClick(list)} text={list.title} className="" />)} 
            {selectList &&
                <>
                 <br/>
                 <br/>
                <Dropdown  selectedKey={selectValue} onChange={onSetSeletedValue} options={getSelectListOptions()}></Dropdown>
                <br/>
                Kommentar:
                <br/>
                <TextField placeholder="Fri tekst" value={description} multiline={true} onChange={onTextChange}></TextField>
                 <PrimaryButton text="  Upload billede" onClick={onUploadClick} className="uploadbtn" primary={true} iconProps={{ iconName: "Upload", }}>
            
                </PrimaryButton>
                {file ? <><a target="_blank" href={URL.createObjectURL(file)}>{file.name}</a><br/></> : null}
                <input ref={inputFileRef} id="uploadFile" hidden={true} type="file" accept="image/*" onChange={handleImageUpload}></input>
                {selectList && description && <PrimaryButton onClick={onSubmit}>Indsend</PrimaryButton>}
               </>
            }

        </Dialog>

        <DefaultButton title="Du skal vælge en montør før du kan give feedback" disabled={props.worker === null || props.worker === undefined || props.worker === ""} onClick={onFeedbackClick} text="Feedback" className="feedback" />
    </>;
};

const mapStateToProps = (state: RootState) => {
    return {
        selectList: getSelectList(state, "Feedback"),
        user: getUserInformation(state)
    };
};

const mapToDispatchProps = (dispatch: Dispatch<Action>) => ({
    loadSelectList: () =>  dispatch<any>(loadSelectList()),
    createFeedback: (feedback: Feedback) =>  dispatch<any>(createFeedback(feedback)),
    
  
});

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapToDispatchProps>;

export default connect(mapStateToProps, mapToDispatchProps)(Feedback);
    